import { FilterMetadata } from 'primeng/api';
// import { TableLazyLoadEvent } from 'primeng/table';
import { DataSort } from './table-request.model';
import { ResultWrapper } from '@seahorse/common';

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
export class PagedList<TEntity> {
  static empty<TEntity>(pageSize?: number): PagedList<TEntity> {
    return {
      page: 0,
      pageSize: pageSize || 0,
      totalCount: 0,
      totalPages: 0,
      items: [],
    };
  }

  static fromList<TEntity>(
    list: TEntity[],
    pageSize?: number
  ): PagedList<TEntity> {
    pageSize = pageSize || list.length || 0;

    return {
      pageSize: pageSize,
      totalCount: list?.length,
      totalPages: Math.ceil((list?.length || 0) / pageSize),
      items: list,
      page: 1,
    };
  }

  static fromResponse<TEntity>(
    response: ResultWrapper<TEntity[]>,
    pageSize: number,
    pageIndex?: number
  ): PagedList<TEntity> {
    // temporary fix for incorrect totalCount coming from the server
    const totalCount =
      response.result?.length > response.count
        ? response.result?.length
        : response.count;

    const firstIndex = pageIndex != null ? pageIndex * pageSize : undefined;

    return {
      pageSize: pageSize,
      totalCount: totalCount || 0,
      totalPages: Math.ceil((totalCount || 0) / pageSize),
      items: response.result || [],
      page: pageIndex ?? 1,
      firstIndex,
    };
  }
}

export interface PagedList<TEntity> {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  items: TEntity[];
  firstIndex?: number;
}

export class PagedListRequest<TData> {
  [key: string]: any;

  page = 1;
  size = 10;
  sort?: DataSort[] | null;
  filters?: Record<string, FilterMetadata | FilterMetadata[] | undefined>;

  constructor(
    data: TData,
    options?: any //TableLazyLoadEvent
  ) {
    if (data != null) {
      Object.assign(this, data);
    }

    const first = options?.first || 0;
    const rows = options?.rows || 10;
    this.page = first / rows + 1;
    this.size = rows;

    this.filters = options?.filters;
    this.sort = options?.multiSortMeta;
  }
}
